export default "__VITE_ASSET__zQ4o5f8o__"